import { Fragment } from "react"
import AddressTableRows from "./AddressTableRows"

function AddressTable({isAdding, deleteTableRow, addTableRow}) {
  return(
      <Fragment>
          <AddressTableRows isAdding={isAdding} deleteTableRow={deleteTableRow}/>
          <tr>
            <td className="text-end" colSpan={8} bgcolor="white">
              {!isAdding ? (
                <button type="button" className="btn btn-primary" onClick={addTableRow} >+ Add Address</button>
              ) : (
                <button type="submit" className="btn btn-success" >Save Addresses</button>
              )}
            </td>
          </tr>
      </Fragment>
  )
}

export default AddressTable;